/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Original_BrowseInputs */

const en_audio_embed_export_original_browse = /** @type {(inputs: Audio_Embed_Export_Original_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse`)
};

const fr_audio_embed_export_original_browse = /** @type {(inputs: Audio_Embed_Export_Original_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parcourir`)
};

const de_audio_embed_export_original_browse = /** @type {(inputs: Audio_Embed_Export_Original_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durchsuchen`)
};

const it_audio_embed_export_original_browse = /** @type {(inputs: Audio_Embed_Export_Original_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sfoglia`)
};

const ru_audio_embed_export_original_browse = /** @type {(inputs: Audio_Embed_Export_Original_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Просматривать`)
};

const es_audio_embed_export_original_browse = /** @type {(inputs: Audio_Embed_Export_Original_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navegar`)
};

const zh_cn2_audio_embed_export_original_browse = /** @type {(inputs: Audio_Embed_Export_Original_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浏览`)
};

const ja_audio_embed_export_original_browse = /** @type {(inputs: Audio_Embed_Export_Original_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブラウズ`)
};

const hi_audio_embed_export_original_browse = /** @type {(inputs: Audio_Embed_Export_Original_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ब्राउज़`)
};

const pt_pt2_audio_embed_export_original_browse = /** @type {(inputs: Audio_Embed_Export_Original_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navegar`)
};

/**
* | output |
* | --- |
* | "Browse" |
*
* @param {Audio_Embed_Export_Original_BrowseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_original_browse = /** @type {((inputs?: Audio_Embed_Export_Original_BrowseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Original_BrowseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_original_browse(inputs)
	if (locale === "de") return de_audio_embed_export_original_browse(inputs)
	if (locale === "it") return it_audio_embed_export_original_browse(inputs)
	if (locale === "ru") return ru_audio_embed_export_original_browse(inputs)
	if (locale === "es") return es_audio_embed_export_original_browse(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_original_browse(inputs)
	if (locale === "ja") return ja_audio_embed_export_original_browse(inputs)
	if (locale === "hi") return hi_audio_embed_export_original_browse(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_original_browse(inputs)
	return en_audio_embed_export_original_browse(inputs)
});